import { ModalProvider } from "../../providers/ModalProvider";
import AuthHomepage from "@/pages/AuthHomepage";

export const FallbackHomePage = () => {
    return (
      <ModalProvider>
          <AuthHomepage />
      </ModalProvider>
    )
  };
